module.exports = __webpack_public_path__ + "img/coke-zero_1.dbcb9ac8.jpg";